/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface FcmControllerUpsertFcmToken$Params {
  token: string;
  memberRole: 'PARENT' | 'TEACHER';
}

export function fcmControllerUpsertFcmToken(http: HttpClient, rootUrl: string, params: FcmControllerUpsertFcmToken$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, fcmControllerUpsertFcmToken.PATH, 'patch');
  if (params) {
    rb.query('token', params.token, {});
    rb.query('memberRole', params.memberRole, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

fcmControllerUpsertFcmToken.PATH = '/api/fcm';
